import { Spacing } from '../../lib/types/StyleTypes';

const defSpacing: Spacing = {
  NONE: 0,
  XXS: 1,
  XS: 2,
  S: 3,
  M: 5,
  L: 8,
  XL: 13,
  XXL: 21,
};

export default defSpacing;
